<app-header></app-header>
<div class="container margin-top-70">
  <div class="row">
    <div class="col-md-6 mt-6">
      <div class="row">
        <div class="col-md-6">
          <label class="form-label">Trade Sale Start Date</label>
          <app-date-select
            class="form-control"
            [additionalClasses]="'float-left'"
            type="tradeSaleStartDate"
            (dateSelected)="updateSelectedDate($event)"
          ></app-date-select>
        </div>
        <div class="col-md-6">
          <label class="form-label">Trade Sale End Date</label>
          <app-date-select
            class="form-control"
            [additionalClasses]="'float-left'"
            type="tradeSaleEndDate"
            (dateSelected)="updateSelectedDate($event)"
          ></app-date-select>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container table-responsive mt-2">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchOrders()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
    <button class="btn btn-primary btn-pkt" (click)="clearFilters()">
      Reset<i class="bi bi-trash ps-1"></i>
    </button>
  </div>
</div>

<div>
  <div class="container" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Order Number</th>
          <th scope="col">Response Order ID</th>
          <th scope="col">Email ID</th>
          <th scope="col">Contact Number</th>
          <th scope="col">Order Reason</th>
          <th scope="col">Order Priority</th>
          <th scope="col">Order Status</th>
          <th scope="col">Order Response</th>
          <th scope="col">Description</th>
          <th scope="col">Delivery Note</th>
          <th scope="col">Date Entered</th>
          <th scope="col">Date Modified</th>
          <th scope="col">Assigned User ID</th>
          <th scope="col">Address Street</th>
          <th scope="col">Address Line Two</th>
          <th scope="col">Address Line Three</th>
          <th scope="col">Address City</th>
          <th scope="col">Address State</th>
          <th scope="col">Address Country</th>
          <th scope="col">Address Postalcode</th>
          <th scope="col">Product ID</th>
          <th scope="col">Product ISBN</th>
          <th scope="col">Format</th>
          <th scope="col">Voucher Codes</th>
          <th scope="col">Status</th>
          <th scope="col">Status Date</th>
          <th scope="col">Shipping Provider</th>
          <th scope="col">Shipping Code</th>
          <th scope="col">Tracking ID</th>
          <th scope="col">Shipping Priority</th>
          <th scope="col">Quantity</th>
          <th scope="col">Price</th>
          <th scope="col">Tax</th>
          <th scope="col">Estimate Delivery</th>
          <th scope="col">Contact First Name</th>
          <th scope="col">Contact Last Name</th>
          <th scope="col">User First Name</th>
          <th scope="col">User Last Name</th>
          <th scope="col">Modified User ID</th>
          <th scope="col">Created By</th>
          <th scope="col">Deleted</th>
          <th scope="col">Billing Account ID</th>
          <th scope="col">Billing Contact ID</th>
          <th scope="col">Billing Address Street</th>
          <th scope="col">Billing Address City</th>
          <th scope="col">Billing Address State</th>
          <th scope="col">Billing Address Postalcode</th>
          <th scope="col">Billing Address Country</th>
          <th scope="col">Shipping Address Street</th>
          <th scope="col">Shipping Address City</th>
          <th scope="col">Shipping Address State</th>
          <th scope="col">Shipping Address Postalcode</th>
          <th scope="col">Shipping Address Country</th>
          <th scope="col">Number</th>
          <th scope="col">Total Amt</th>
          <th scope="col">Total Amt USD</th>
          <th scope="col">Subtotal Amount</th>
          <th scope="col">Subtotal Amount USD</th>
          <th scope="col">Discount Amount</th>
          <th scope="col">Discount Amount USD</th>
          <th scope="col">Tax Amount</th>
          <th scope="col">Tax Amount USD</th>
          <th scope="col">Shipping Amount</th>
          <th scope="col">Shipping Amount USD</th>
          <th scope="col">Shipping Tax</th>
          <th scope="col">Shipping Tax Amt</th>
          <th scope="col">Shipping Tax Amt USD</th>
          <th scope="col">Total Amount</th>
          <th scope="col">Total Amount USD</th>
          <th scope="col">Currency ID</th>
          <th scope="col">Quote Number</th>
          <th scope="col">Quote Date</th>
          <th scope="col">Invoice Date</th>
          <th scope="col">Due Date</th>
          <th scope="col">Template DDown</th>
          <th scope="col">Subtotal Tax Amount</th>
          <th scope="col">Subtotal Tax Amount USD</th>
          <th scope="col">Cust PO Ref</th>
          <th scope="col">Ref Order Date</th>
          <th scope="col">Cust VAT No</th>
          <th scope="col">Customer Type</th>
          <th scope="col">Payment Mode</th>
          <th scope="col">Payment Type</th>
          <th scope="col">Date To</th>
          <th scope="col">Date From</th>
          <th scope="col">Order Source</th>
          <th scope="col">External Order</th>
          <th scope="col">External Order Ref Date</th>
          <th scope="col">Invoice Type</th>
          <th scope="col">Approve Date</th>
          <th scope="col">Exchange Rate</th>
          <th scope="col">Contract Royalty Lineitems ID</th>
          <th scope="col">Contract ID</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let order of orders; let i = index;">
          <td>{{ order.id ? order.id : '-' }}</td>
          <td>{{ order.order_number ? order.order_number : '-' }}</td>
          <td>{{ order.response_order_id ? order.response_order_id : '-' }}</td>
          <td>{{ order.email_id ? order.email_id : '-' }}</td>
          <td>{{ order.contact_number ? order.contact_number : '-' }}</td>
          <td>{{ order.odr_reason ? order.odr_reason : '-' }}</td>
          <td>{{ order.order_priority ? order.order_priority : '-' }}</td>
          <td>{{ order.order_status ? order.order_status : '-' }}</td>
          <td>
            {{ order.order_response && order.order_response.trim() !== '' ? order.order_response : '-' }}
          </td>
          <td>{{ order.description ? order.description : '-' }}</td>
          <td>{{ order.delivery_note ? order.delivery_note : '-' }}</td>
          <td>{{ order.date_entered ? order.date_entered : '-' }}</td>
          <td>{{ order.date_modified ? order.date_modified : '-' }}</td>
          <td>{{ order.assigned_user_id ? order.assigned_user_id : '-' }}</td>
          <td>{{ order.address_street ? order.address_street : '-' }}</td>
          <td>{{ order.address_line_two ? order.address_line_two : '-' }}</td>
          <td>{{ order.address_line_three ? order.address_line_three : '-' }}</td>
          <td>{{ order.address_city ? order.address_city : '-' }}</td>
          <td>{{ order.address_state ? order.address_state : '-' }}</td>
          <td>{{ order.address_country ? order.address_country : '-' }}</td>
          <td>{{ order.address_postalcode ? order.address_postalcode : '-' }}</td>
          <td>{{ order.product_id ? order.product_id : '-' }}</td>
          <td>{{ order.product_isbn ? order.product_isbn : '-' }}</td>
          <td>{{ order.format ? order.format : '-' }}</td>
          <td>{{ order.voucher_codes ? order.voucher_codes : '-' }}</td>
          <td>{{ order.status ? order.status : '-' }}</td>
          <td>{{ order.status_date ? order.status_date : '-' }}</td>
          <td>{{ order.shipping_provider ? order.shipping_provider : '-' }}</td>
          <td>{{ order.shipping_code ? order.shipping_code : '-' }}</td>
          <td>{{ order.tracking_id ? order.tracking_id : '-' }}</td>
          <td>{{ order.shipping_priority ? order.shipping_priority : '-' }}</td>
          <td>{{ order.quantity !== undefined && order.quantity !== null ? order.quantity : '-' }}</td>
          <td>{{ order.price ? order.price : '-' }}</td>
          <td>{{ order.tax ? order.tax : '-' }}</td>
          <td>{{ order.estimate_delivery ? order.estimate_delivery : '-' }}</td>   
          <td>{{ order.contact_first_name ? order.contact_first_name : '-' }}</td>
          <td>{{ order.contact_last_name ? order.contact_last_name : '-' }}</td>
          <td>{{ order.user_first_name ? order.user_first_name : '-' }}</td>
          <td>{{ order.user_last_name ? order.user_last_name : '-' }}</td>
          <td>{{ order.modified_user_id ? order.modified_user_id : '-' }}</td>
          <td>{{ order.created_by ? order.created_by : '-' }}</td>
          <td>{{ order.deleted !== undefined && order.deleted !== null ? order.deleted : '-' }}</td>
          <td>{{ order.billing_account_id ? order.billing_account_id : '-' }}</td>
          <td>{{ order.billing_contact_id ? order.billing_contact_id : '-' }}</td>
          <td>{{ order.billing_address_street ? order.billing_address_street : '-' }}</td>
          <td>{{ order.billing_address_city ? order.billing_address_city : '-' }}</td>
          <td>{{ order.billing_address_state ? order.billing_address_state : '-' }}</td>
          <td>{{ order.billing_address_postalcode ? order.billing_address_postalcode : '-' }}</td>
          <td>{{ order.billing_address_country ? order.billing_address_country : '-' }}</td>
          <td>{{ order.shipping_address_street ? order.shipping_address_street : '-' }}</td>
          <td>{{ order.shipping_address_city ? order.shipping_address_city : '-' }}</td>
          <td>{{ order.shipping_address_state ? order.shipping_address_state : '-' }}</td>
          <td>{{ order.shipping_address_postalcode ? order.shipping_address_postalcode : '-' }}</td>
          <td>{{ order.shipping_address_country ? order.shipping_address_country : '-' }}</td>
          <td>{{ order.number !== undefined && order.number !== null ? order.number : '-' }}</td>
          <td>{{ order.total_amt ? order.total_amt : '-' }}</td>
          <td>{{ order.total_amt_usdollar ? order.total_amt_usdollar : '-' }}</td>
          <td>{{ order.subtotal_amount ? order.subtotal_amount : '-' }}</td>
          <td>{{ order.subtotal_amount_usdollar ? order.subtotal_amount_usdollar : '-' }}</td>
          <td>{{ order.discount_amount ? order.discount_amount : '-' }}</td>
          <td>{{ order.discount_amount_usdollar ? order.discount_amount_usdollar : '-' }}</td>
          <td>{{ order.tax_amount ? order.tax_amount : '-' }}</td>
          <td>{{ order.tax_amount_usdollar ? order.tax_amount_usdollar : '-' }}</td>
          <td>{{ order.shipping_amount ? order.shipping_amount : '-' }}</td>
          <td>{{ order.shipping_amount_usdollar ? order.shipping_amount_usdollar : '-' }}</td>
          <td>{{ order.shipping_tax ? order.shipping_tax : '-' }}</td>
          <td>{{ order.shipping_tax_amt ? order.shipping_tax_amt : '-' }}</td>
          <td>{{ order.shipping_tax_amt_usdollar ? order.shipping_tax_amt_usdollar : '-' }}</td>
          <td>{{ order.total_amount ? order.total_amount : '-' }}</td>
          <td>{{ order.total_amount_usdollar ? order.total_amount_usdollar : '-' }}</td>
          <td>{{ order.currency_id ? order.currency_id : '-' }}</td>
          <td>{{ order.quote_number !== undefined && order.quote_number !== null ? order.quote_number : '-' }}</td>
          <td>{{ order.quote_date ? order.quote_date : '-' }}</td>
          <td>{{ order.invoice_date ? order.invoice_date : '-' }}</td>
          <td>{{ order.due_date ? order.due_date : '-' }}</td>
          <td>{{ order.template_ddown_c ? order.template_ddown_c : '-' }}</td>
          <td>{{ order.subtotal_tax_amount ? order.subtotal_tax_amount : '-' }}</td>
          <td>{{ order.subtotal_tax_amount_usdollar ? order.subtotal_tax_amount_usdollar : '-' }}</td>
          <td>{{ order.cust_po_ref ? order.cust_po_ref : '-' }}</td>
          <td>{{ order.ref_order_date ? order.ref_order_date : '-' }}</td>
          <td>{{ order.cust_vat_no ? order.cust_vat_no : '-' }}</td>
          <td>{{ order.customer_type ? order.customer_type : '-' }}</td>
          <td>{{ order.payment_mode ? order.payment_mode : '-' }}</td>
          <td>{{ order.payment_type ? order.payment_type : '-' }}</td>
          <td>{{ order.date_to ? order.date_to : '-' }}</td>
          <td>{{ order.date_from ? order.date_from : '-' }}</td>
          <td>{{ order.order_source ? order.order_source : '-' }}</td>
          <td>{{ order.external_order ? order.external_order : '-' }}</td>
          <td>{{ order.external_order_ref_date ? order.external_order_ref_date : '-' }}</td>
          <td>{{ order.invoice_type ? order.invoice_type : '-' }}</td>
          <td>{{ order.approve_date ? order.approve_date : '-' }}</td>
          <td>{{ order.exchange_rate ? order.exchange_rate : '-' }}</td>
          <td>{{ order.contract_royalty_lineitems_id ? order.contract_royalty_lineitems_id : '-' }}</td>
          <td>{{ order.contract_id ? order.contract_id : '-' }}</td>
        </tr>
        <tr *ngIf="!orders || orders.length === 0">
          <td colspan="87" class="text-center">No records found.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalOrders"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>



<ngb-toast
  class="toast-container position-fixed slide-in-right shake-effect"
  style="z-index: 1200; background-color: #dc3545; color: aliceblue; top: 15px; right: 15px;"
  *ngIf="errorToastShow"
  [autohide]="true"
  (hidden)="errorToastShow=false"
>
  Something went wrong
</ngb-toast>

